import { useState, useEffect } from 'react';
import { Save, Facebook } from 'lucide-react';

interface Configuration {
  meta_pixel_id?: string;
  meta_access_token?: string;
}

const Configuracoes = () => {
  const [config, setConfig] = useState<Configuration>({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadConfigurations();
  }, []);

  const loadConfigurations = async () => {
    try {
      const response = await fetch('/api/configurations', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        setConfig(data.data || {});
      }
    } catch (error) {
      console.error('Error loading configurations:', error);
    } finally {
      setLoading(false);
    }
  };

  const saveConfigurations = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/configurations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(config)
      });

      if (response.ok) {
        alert('Configurações salvas com sucesso\!');
      } else {
        alert('Erro ao salvar configurações');
      }
    } catch (error) {
      console.error('Error saving configurations:', error);
      alert('Erro ao salvar configurações');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Carregando configurações...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Configurações do Meta Pixel</h1>
        <p className="text-gray-600 mt-1">Configure o Meta Pixel para rastreamento de eventos</p>
      </div>

      {/* Meta Pixel */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200">
        <div className="p-6">
          <div className="space-y-6">
            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                <Facebook className="h-5 w-5 mr-2 text-blue-600" />
                Meta Pixel (Facebook)
              </h3>
              
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Pixel ID
                    </label>
                    <input
                      type="text"
                      value={config.meta_pixel_id || ''}
                      onChange={(e) => setConfig({...config, meta_pixel_id: e.target.value})}
                      placeholder="123456789012345"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      ID do Pixel do Facebook/Meta
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Access Token
                    </label>
                    <input
                      type="password"
                      value={config.meta_access_token || ''}
                      onChange={(e) => setConfig({...config, meta_access_token: e.target.value})}
                      placeholder="EAAxxxxxxxxxx..."
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Token de acesso para Conversions API
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => saveConfigurations()}
                  disabled={saving}
                  className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  <Save className="h-4 w-4 mr-2" />
                  {saving ? 'Salvando...' : 'Salvar Meta Pixel'}
                </button>
              </div>

              {/* Informações sobre Meta Pixel */}
              <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <h4 className="text-sm font-medium text-blue-900 mb-2">📊 Como configurar o Meta Pixel</h4>
                <ol className="text-sm text-blue-700 space-y-1">
                  <li>1. Acesse o <a href="https://business.facebook.com/events_manager2" target="_blank" rel="noopener noreferrer" className="underline">Gerenciador de Eventos</a></li>
                  <li>2. Selecione seu Pixel ou crie um novo</li>
                  <li>3. Copie o Pixel ID (número de 15 dígitos)</li>
                  <li>4. Gere um Access Token em Configurações &gt; Conversions API</li>
                  <li>5. Cole as credenciais nos campos acima</li>
                </ol>
                <div className="mt-2 text-xs text-blue-600">
                  <strong>Funcionalidades:</strong> Rastreamento de eventos (PageView, Purchase, AddToCart, etc.), Conversions API para eventos server-side
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Configuracoes;
